@if (componentLoaded) {
  <div class="d-flex mb-3 w-100 overflow-auto">
    @if (dataSource.length > 0) {
    <table class="table table-responsive table-sm">
      <thead>
        <tr>
          @if (hasSelection) {
          <th class="table-column-max-width" scope="col" style="font-size: 16px">
            <!-- <div class="form-check">
              <input
                class="form-check-input border-primary mt-2 mb-1"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                (change)="$event ? masterSelectionAll() : null"
                [checked]="
                  selection.hasValue() &&
                  isAllSelected() &&
                  dataSource &&
                  dataSource.length > 0
                "
                [disabled]="!editable || !isCheckboxEnabled"
              />
            </div> -->
          </th>
          }
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('nomeRisorsa')"
            title="Risorsa"
          >
            <div class="d-flex align-items-center">
              Risorsa
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('nomeRisorsa', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('nomeRisorsa', true)"
                ></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('nomeResponsabile')"
            scope="col"
            title="Responsabile Gerarchico"
          >
            <div class="d-flex align-items-center">
              Responsabile Gerarchico
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('nomeResponsabile', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('nomeResponsabile', true)"
                ></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('descrizioneUnitaOrganizzativa')"
            scope="col"
            title="Unità Organizzativa"
          >
            <div class="d-flex align-items-center">
              Unità Organizzativa
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('descrizioneUnitaOrganizzativa', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('descrizioneUnitaOrganizzativa', true)"
                ></i>
              </div>
            </div>
          </th>
          @if (utente.hasDelegheAttive) {
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('nomeDelegante')"
            scope="col"
            title="Delegante"
          >
            <div class="d-flex align-items-center">
              Delegante
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('nomeDelegante', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('nomeDelegante', true)"
                ></i>
              </div>
            </div>
          </th>
          }
          <th class="table-column-max-width text-slate-800" scope="col" style="max-width: 80px">
            <div class="d-flex align-items-center">
              Dettaglio
              <div class="ms-1 position-relative min-height-th-home"></div>
            </div>
          </th>
          <!-- @if ([attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore)) {
          <th class="table-column-max-width text-slate-800" scope="col">
            <div class="d-flex align-items-center">
              Approvazione
              <div class="ms-1 position-relative min-height-th-home"></div>
            </div>
          </th>
          } -->
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('modificato')"
            scope="col"
            title="Timesheet modificato"
          >
            <div class="d-flex align-items-center">
              Timesheet modificato
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('modificato', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('modificato', true)"
                ></i>
              </div>
            </div>
          </th>
          @if ([attori.ControllerCentrale].includes(attore)) {
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('nomeApprovatore')"
            scope="col"
            title="Utente approvatore"
          >
            <div class="d-flex align-items-center">
              Utente approvatore
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('nomeApprovatore', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('nomeApprovatore', true)"
                ></i>
              </div>
            </div>
          </th>
          }
          <th
            class="table-column-max-width text-slate-800"
            role="button"
            (click)="sort('dataApprovazione')"
            scope="col"
            title="Data approvazione"
          >
            <div class="d-flex align-items-center">
              Data approvazione
              <div class="ms-1 position-relative min-height-th-home">
                <i
                  class="bi position-absolute top-0"
                  [ngClass]="getCaretClass('dataApprovazione', false)"
                ></i>
                <i
                  class="bi position-absolute bottom-0"
                  [ngClass]="getCaretClass('dataApprovazione', true)"
                ></i>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (element of dataSource; track $index) {
        <tr [class.table-success]="element.nomeDelegante">
          @if (hasSelection) {
          <td>
            @if (!(utente.hasDelegheAttive && [attori.ControllerCentrale].includes(attore) && !element.nomeDelegante)) {
            <div class="form-check">
              <input
                class="form-check-input mt-2 border-primary"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                (change)="masterSelection(element)"
                [checked]="selection.hasValue() && selection.isSelected(element)"
                [disabled]="
                  !editable || element.dataApprovazione != null ||
                  (dataSource && !dataSource.length)
                "
              />
            </div>
            }
          </td>
          }
          <td class="table-column-max-width">
            <span class="fw-semibold" [matTooltip]="element.nomeRisorsa ?? ''">
              {{ element.nomeRisorsa }}
            </span>
            <br />
            <span class="text-slate-700" [title]="element.risorsa">
              {{ element.risorsa }}
            </span>
          </td>
          <td
            class="table-column-max-width text-slate-700"
            [matTooltip]="element.nomeResponsabile ?? ''"
          >
            {{ element.nomeResponsabile }}
          </td>
          <td class="table-column-max-width" style="max-width: 250px">
            @if ([attori.CFO, attori.DirettoreGenerale, attori.ControllerCentrale].includes(attore)) {
              <span class="fw-semibold" [matTooltip]="element.descrizioneUnitaOrganizzativaPrimoLivello ?? ''">
                {{ element.descrizioneUnitaOrganizzativaPrimoLivello }}
              </span>
              <br />
              <span class="text-slate-700" [matTooltip]="element.descrizioneUnitaOrganizzativa ?? ''">
                {{ element.descrizioneUnitaOrganizzativa }}
              </span>
            } @else {
              <span class="text-slate-700" [matTooltip]="element.descrizioneUnitaOrganizzativa ?? ''">
                {{ element.descrizioneUnitaOrganizzativa }}
              </span>
            }
          </td>
          @if (utente.hasDelegheAttive) {
          <td
            class="table-column-max-width text-slate-700"
            [matTooltip]="element.nomeDelegante ?? ''"
          >
            {{ element.nomeDelegante }}
          </td>
          }
          <td class="table-column-max-width">
            <a
              class="text-decoration-none"
              (click)="onIconClick(element, 'dettaglio')"
              onclick="return false"
              matTooltip="Dettaglio"
              href="/"
            >
              <i class="bi bi-search fs-5 me-2"></i>
            </a>
          </td>
          <!-- @if ([attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore)) {
          <td class="table-column-max-width">
            @if (element.dataApprovazione == null) {
            <a
              class="text-decoration-none"
              (click)="onIconClick(element, 'approvazione')"
              onclick="return false"
              matTooltip="Approvazione"
              href="/"
            >
              <i class="bi bi-check2-square fs-5 me-2"></i>
            </a>
            }
          </td>
          } -->
          <td
            class="table-column-max-width text-slate-700"
            [title]="element.modificato ? 'Sì' : 'No'"
          >
            {{ element.modificato ? "Sì" : "No" }}
          </td>
          @if ([attori.ControllerCentrale].includes(attore)) {
          <td
            class="table-column-max-width text-slate-700"
            [matTooltip]="element.nomeApprovatore ?? ''"
          >
            {{ element.nomeApprovatore }}
          </td>
          }
          <td
            class="table-column-max-width text-slate-700"
            [title]="element.dataApprovazione ? element.dataApprovazione : ''">
            {{ element.dataApprovazione }}
          </td>
        </tr>
        }
      </tbody>
    </table>
    } @else {
    <p class="w-100 text-center">Nessuna risorsa trovata</p>
    }
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <span class="text-slate-700 ps-3 mb-3">
      {{
        elencoCount > 0
          ? elencoCount > 1
            ? elencoCount + " risorse trovate"
            : elencoCount + " risorsa trovata"
          : ""
      }}
    </span>

    <pagination
      *ngIf="totalPages > 0"
      alignment="end"
      [currentPage]="currentPage"
      [pageNumbers]="totalPages"
      [currentChanger]="pageOffset"
      (changerEvent)="changerEvent($event)"
      (pageEvent)="getPage($event)"
    >
    </pagination>
  </div>
  } @else {
  <ngx-skeleton-loader count="10" appearance="line" />
  }
